module.exports = __webpack_public_path__ + "static/sui-button-positive-2738c4590e1341d7d2c80d2b95d5959f.png";